import React, { Component, useMemo } from "react";
import { Link, Route, useLocation } from "react-router-dom";
import DataTable from "../_Components/DataTable";
import _ from "lodash";
import { Button } from "react-bootstrap";
import SplitNumber from "../_Components/SplitNumber";
import classNames from "classnames";

function DataGrid({
  data,
  setShowModalSupplier,
  setSelectedSupplier,
  setShowModalEditUserName,
  setSelectedUserId,
  setShowAddAgentToSupplierModal,
}) {
  const columns = useMemo(() => [
    {
      accessor: "id",
      Header: "#",
      minWidth: 50,
    },
    {
      accessor: "companyName",
      Header: "نام شرکت    ",
      minWidth: "100px",
    },
    {
      Header: "مدیر عامل",
      minWidth: "100px",
      align: "center",
      Cell: ({ row }) => (
        <>
          <span className="mr-1 d-inline-block">
            {row.original.ceoFirstName === "null" || row.original.ceoFirstName === null
              ? " "
              : row.original.ceoFirstName}
          </span>
          <span className="d-inline-block">
            {row.original.ceoLastName === "null" || row.original.ceoLastName === null ? " " : row.original.ceoLastName}
          </span>
        </>
      ),
    },
    {
      accessor: "phoneNumber",
      Header: "شماره تماس",
      minWidth: "100px",
    },
    {
      accessor: "cityName",
      Header: "شهر",
      minWidth: "50px",
    },
    {
      accessor: "supplierApprovalStatusS",
      Header: "وضعیت",
      minWidth: "100px",
      Cell: ({ row }) => (
        <div
          className={`rounded-pill px-5 py-1 d-inline-block ${row.original.supplierApprovalStatus === 3 ? "bg-light-success  text-success" : row.original.supplierApprovalStatus === 4 ? "bg-light-danger text-danger" : row.original.supplierApprovalStatus === 2 ? "bg-light-primary text-primary" : ""}`}
        >
          {row.original.supplierApprovalStatusS}
        </div>
      ),
    },
    {
      accessor: "riallBalance",
      Header: "موجودی کیف پول",
      minWidth: "100px",
      Cell: ({ row }) => (
        <div>
          <SplitNumber number={row.original.riallBalance} />
        </div>
      ),
    },
    {
      accessor: "createdPersianTime",
      Header: "زمان ایجاد",
      minWidth: "50px",
    },
    {
      Header: "عملیات",
      accessor: "",
      minWidth: 150,
      align: "center",
      Cell: ({ row }) => (
        <div className="text-center">
          <Button
            className="btn btn-light-primary btn-sm mr-2 btn-icon"
            title="ویرایش"
            onClick={() => {
              setSelectedSupplier(row.original.id);
              setShowModalSupplier(true);
            }}
          >
            <i className="far fa-edit text-small"></i>
          </Button>
          <Button
            className="btn btn-light-primary btn-sm mr-2 btn-icon"
            title="ویرایش نام کاربری"
            onClick={() => {
              setSelectedUserId(row.original.id);
              setShowModalEditUserName(true);
            }}
          >
            <i className="far fa-user text-small"></i>
          </Button>
          <Button
            className="btn btn-light-primary btn-sm mr-2 btn-icon"
            onClick={() => {
              setSelectedUserId(row.original.id);
              setShowAddAgentToSupplierModal(true);
            }}
            title="اضافه کردن تامین کننده به نماینده"
          >
            <i className="fa fa-plus text-small "></i>
          </Button>
        </div>
      ),
    },
  ]);

  const config = {
    page_size: 10,
    length_menu: [10, 20, 50, 100],
    show_filter: false,
    show_pagination: true,
    pagination: "advance",
    button: {
      excel: false,
      print: false,
    },
    language: {
      length_menu: " _MENU_  رکورد در هر صفحه",
      filter: "جستجو ...",
      info: " _START_ - _END_ از _TOTAL_ رکورد",
      pagination: {
        first: "First",
        previous: <i className="fa fa-chevron-right"></i>,
        next: <i className="fa fa-chevron-left"></i>,
        last: "Last",
      },
    },
  };

  return (
    <div>
      <DataTable config={config} columns={columns} data={data} />
    </div>
  );
}

export default DataGrid;
